<template>

    <div class="dayspicker">
        <v-checkbox
            class="mr-10"
            v-for="(day, index) in days"
            :key="day"
            :label="day"
            :model="isChecked(index)"
            @input="update(index, $event)">
        </v-checkbox>
    </div>

</template>

<style scoped lang="scss">

    .dayspicker {
        display: flex;
        margin: 5px 0;
    }

</style>

<script>

export default {

    props: {
        model: {
            required: true,
            type: Array,
        },
    },

    data() {
        return {
            val: this.model,
            days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        }
    },

    watch: {

        model(val) {
            this.val = val;
        },

        val(val) {
            this.$emit('input', val);
        },

    },

    methods: {

        isChecked(val) {
            return this.val.includes(val);
        },

        update(val, checked) {
            if (checked && !this.val.includes(val)) {
                this.val.push(val);
                this.val.sort();
            } else if (!checked && this.val.includes(val)) {
                this.val.splice(this.val.indexOf(val), 1);
            }
        }

    },

}

</script>
